import CryptoJsAdapter from "../CryptoJsAdapter/CryptoJsAdapter";

export default class KLYUserDataExchange {
  static getPayload() {
    const gtm = window.kmklabs.gtm;
    const payload = {};

    payload.name = gtm.user_full_name;
    payload.email = gtm.ue;
    payload.phone = gtm.pn;
    gtm.user_gender !== "unknown" && (payload.gender = gtm.user_gender);
    gtm.user_birthdate !== null && (payload.birthday = gtm.user_birthdate);
    payload.visitor_id = gtm.visitor_id;
    window.ga && window.ga.getAll() && window.ga.getAll()[0] && window.ga.getAll()[0].get && (payload.gaid = window.ga.getAll()[0].get('clientId'));

    return payload;
  }

  static getKey() {
    return "3OIetr3pmXVl1t39";
  }

  static encrypt(cipherText) {
    return CryptoJsAdapter.aesEncrypt(cipherText, KLYUserDataExchange.getKey());
  }

  static decrypt(decryptedText) {
    return CryptoJsAdapter.aesDecrypt(decryptedText, KLYUserDataExchange.getKey());
  }
}
